export const STRIPE_SESSION_ID_QS_PARAM = "session_id={CHECKOUT_SESSION_ID}";

const ACCESS_DENIED = "access_denied";
const INVALID_SCOPE = "invalid_scope";
const INVALID_REDIRECT_URI = "invalid_redirect_uri";
const INVALID_REQUEST = "invalid_request";
const UNSUPPORTED_RESPONSE_TYPE = "unsupported_response_type";

export const STRIPE_OAUTH_ERROR_CONTENT = {
  [ACCESS_DENIED]: {
    title: "Authorization denied",
    body: [`That authorization failed. Click to try again.`]
  },
  [INVALID_REQUEST]: {
    title: "Request error",
    body: [`There was a problem with that request. Click to try again.`]
  }
};

// https://stripe.com/docs/connect/oauth-reference#get-authorize-error-codes
export const STRIPE_OAUTH_ERROR = {
  ACCESS_DENIED,
  INVALID_SCOPE,
  INVALID_REDIRECT_URI,
  INVALID_REQUEST,
  UNSUPPORTED_RESPONSE_TYPE
};

export const STRIPE_ROUTES = {
  ACCOUNT: "settings/account",
  BRANDING: "setings/branding",
  UPDATE: "setings/update",
  VERIFICATIONS: "setings/verifications",
  PRODUCTS: "products",
  PAYMENT_METHODS: "settings/payments"
};

export const STRIPE_BENEFITS_LIST = [
  {
    icon: "checkmarkCircle",
    copy: "PCI DSS compliance Level 1 certification."
  },
  {
    icon: "checkmarkCircle",
    copy: "Money Transmitter Licenses across US."
  },
  {
    icon: "checkmarkCircle",
    copy: "PSD2 and Strong Customer Authentication (SCA) compliant."
  }
];

export const STRIPE_IDENTITY_LIST = [
  {
    icon: "store",
    copy: "Business information and identification."
  },
  {
    icon: "bank",
    copy: "Bank account information."
  },
  {
    icon: "globe",
    copy: "Website information and verification."
  }
];

export const SELL_ANYTHING_LIST = [
  {
    icon: "checkmarkCircle",
    copy: "Create one time or recurring charges."
  },
  {
    icon: "checkmarkCircle",
    copy: "Set prices in different currencies."
  },
  {
    icon: "checkmarkCircle",
    copy: "Accept Apple Pay and Google Pay."
  },
  {
    icon: "checkmarkCircle",
    copy: "Apply discounts, tax rates and more."
  }
];

export const SELL_ANYWHERE_LIST = [
  {
    icon: "checkmarkCircle",
    copy:
      "Accept payments in your customers preferred payment method including Apple Pay and Google Wallet."
  },
  {
    icon: "checkmarkCircle",
    copy: "Compatible with most CRM and marketing apps."
  },
  {
    icon: "checkmarkCircle",
    copy: "QR codes to enable contactless payments."
  }
];

export const STRIPE_LIST_SECTIONS = [
  {
    header: "Sell anything",
    notation: "*",
    body:
      "Accept payments for any of your products with payment links. Each link can be configured for your use case.",
    list: SELL_ANYTHING_LIST
  },
  {
    header: "Sell anywhere",
    body:
      "Commerce is happening internationally, across multiple channels. Payment links are global and omnichannel ready, allowing you to sell across email, social, in app etc. Payment links can help you sell wherever your customers are.",
    list: SELL_ANYWHERE_LIST
  },
  {
    header: "Simple and secure",
    body:
      "Meet the latest regulatory and compliance requirements through Stripe including built in fraud detection.",
    list: STRIPE_BENEFITS_LIST
  }
];

export const METADATA_FLEX_PRODUCT = "__PB_FLEX_PRODUCT";
